import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      padding: '10px 16px 0',

      ...theme.typography.medium12,
      color: COLORS.gray.gray40,
    },
  }),
  { name: 'ItemSubheader' }
);
